const firebaseConfig = {
  apiKey: 'AIzaSyDVOWbLVsUqdhHD0L8EX8V7tPssz0nqX4U',
  authDomain: 'innovance-case-yusuf.firebaseapp.com',
  projectId: 'innovance-case-yusuf',
  storageBucket: 'innovance-case-yusuf.appspot.com',
  messagingSenderId: '66141914309',
  appId: '1:66141914309:web:5b59fab1a68a2d93e8dcac',
  measurementId: 'G-7XCQPSEZN3',
};

export default firebaseConfig;
